import { useSiteInfo } from "@silvertours/front-entities";
import { useLogin } from "@silvertours/front-features";
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";
export var useHeader = function() {
    var t = useTranslations("features.navigationLegacy.navigation");
    var openingTimesTooltip = useTranslations("features.supportInfoLegacy")("openingTimes.tooltip.title");
    var router = useRouter();
    var ref = useLogin(), loginError = ref.error;
    var ref1 = useSiteInfo(), featureToggles = ref1.settings.featureToggles;
    var translationPrefix = featureToggles.floytPlus ? "floytPlus" : "legacy";
    var translations = {
        loginButton: {
            accountLinks: {
                myBookings: {
                    text: t("login.button.authenticated.menu.myBookings.text"),
                    href: t("login.button.authenticated.menu.myBookings.href")
                },
                myData: {
                    text: t("login.button.authenticated.menu.myData.text"),
                    href: t("login.button.authenticated.menu.myData.href")
                },
                myPayment: {
                    text: t("login.button.authenticated.menu.myPayment.text"),
                    href: t("login.button.authenticated.menu.myPayment.href")
                },
                logout: {
                    text: t("logout.text"),
                    href: t("logout.href")
                }
            },
            account: t("login.button.account"),
            label: t("login.button.label")
        },
        loginModal: {
            actionPath: t("login.href", {
                redirectPath: encodeURIComponent(router.asPath)
            }),
            error: {
                headline: loginError ? t("login.error.".concat(loginError, "Title")) : "",
                message: loginError ? t("login.error.".concat(loginError)) : "",
                passwordLostHref: t("passwordLost.href"),
                passwordLostLabel: t("login.error.resetPasswordLink"),
                resendConfirmUser: t("login.error.resendConfirmUser")
            },
            emailLabel: t("login.emailLabel"),
            loginTitle: t("login.title.".concat(translationPrefix)),
            loginButtonText: t("login.buttonText"),
            newUserHref: t("newUser.".concat(translationPrefix, ".href")),
            newUserText: t("newUser.".concat(translationPrefix, ".text")),
            noAccountText: t("login.noAccountText"),
            passwordLabel: t("login.passwordLabel"),
            passwordLostHref: t("passwordLost.href"),
            passwordLostText: t("passwordLost.text"),
            submitText: t("login.submitText")
        },
        closeMenuLabel: t("header.closeLabel"),
        menuLabel: t("header.menuLabel"),
        openingTimesTooltip: openingTimesTooltip,
        membership: {
            welcomeSubtitle: t("login.membership.".concat(translationPrefix, ".welcomeSubtitle")),
            loginButton: t("login.membership.".concat(translationPrefix, ".loginButton")),
            joinButton: t("login.membership.".concat(translationPrefix, ".joinButton")),
            benefitsSubtitle: t("login.membership.".concat(translationPrefix, ".benefitsSubtitle")),
            benefits: t.raw("login.membership.".concat(translationPrefix, ".benefits")),
            signUpLink: t("newUser.".concat(translationPrefix, ".href")),
            moreInfoLink: featureToggles.floytPlus ? {
                text: t("login.membership.floytPlus.moreInfoLink.text"),
                href: t("login.membership.floytPlus.moreInfoLink.href")
            } : undefined
        }
    };
    return {
        getLinks: function(staticLinks) {
            return staticLinks.filter(function(param) {
                var type = param.type;
                return type === "main";
            });
        },
        translations: translations
    };
};
